import { Fragment } from "react";
import { Outlet } from "react-location";
import { useTranslation } from "react-i18next";
import SSL from "../../assets/ssl-big.png";
import visalLogo from "../../assets/visal-logo.webp";
import LanguageSelector from "components/core/LanguageSelector";

function Auth() {
    const { t } = useTranslation();

    return (
        <Fragment>
            <div className="min-h-screen bg-white flex">
                <div className="hidden lg:block bg-white relative w-0 flex-1">
                    <div className="h-full w-full flex flex-col items-center">
                        <img
                            src={require("../../assets/logo.png")}
                            className="w-1/2 h-1/2 rounded-b-full"
                            alt=""
                        />
                        <div className="space-y-5 w-full flex flex-col items-center h-full">
                            <h4 className="text-xl font-mono w-1/2 mt-3 text-center">
                                {t("auth.description")}
                            </h4>
                            <ul className="bg-red-200 w-[50%] list-disc list-inside p-3 my-4 rounded-lg">
                                <li className={"text-red-800 font-poppins"}>
                                    {t("auth.instructions.email")}
                                </li>
                                <li className={"text-red-800 font-poppins"}>
                                    {t("auth.instructions.otp")}
                                </li>
                            </ul>
                            <h4 className="text-sm w-1/2 font-light mt-3 text-center">
                                {t("auth.login_prompt")}
                            </h4>
                            <div>
                                <h2 className="text-xl font-medium">
                                    {t("auth.our_clients")}
                                </h2>
                            </div>
                            <div className="flex flex-row justify-center items-center space-x-5">
                                <div>
                                    <img
                                        className="h-20 w-32 object-contain rounded-full"
                                        src={visalLogo}
                                        alt=""
                                    />
                                </div>
                                {/* <div>
                                    <img
                                        className="h-32 w-32 object-contain rounded-full"
                                        src="https://kekrebrokerapp.com/static/media/logo-kek-1.921b9b2502d3129fadaa.png"
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <img
                                        className="h-20 w-32 object-contain rounded-non"
                                        src="https://iriskre.com/static/media/irisk-logo-big.c27e3721.png"
                                        alt=""
                                    />
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex-1 bg-gray-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
                    <div className="w-full absolute top-0 z-10 inset-x-0 flex items-center justify-end">
                        <LanguageSelector variant="minimal" />
                    </div>
                    <div className="mx-auto w-full max-w-sm lg:w-96 relative pb-16">
                        {/* Routes go here */}
                        <Outlet />
                        <div className="absolute bottom-0 right-0">
                            <img
                                src={SSL}
                                alt={t("auth.ssl_certificate")}
                                className="w-auto h-12"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Auth;
